import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ah-column-selector',
    templateUrl: './column-selector.component.html',
    styleUrls: ['./column-selector.component.scss'],
    standalone: false
})
export class ColumnSelectorComponent {
    @Input() options: any[];
    @Input() value: any[];
    @Output() onChange: EventEmitter<{
        originalEvent: Event;
        value: any[];
        itemValue: any;
    }> = new EventEmitter();

    constructor() { }

}
